module.exports = __webpack_public_path__ + "img/intro_no.9f023971.svg";